export enum ChallengeSectionTestIds {
    CHALLENGE_SECTION = 'challenge_sec'
}